import { render, staticRenderFns } from "./bet_btn.vue?vue&type=template&id=45f21cd8&"
import script from "./bet_btn.vue?vue&type=script&lang=js&"
export * from "./bet_btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports